module.exports = __webpack_public_path__ + "img/BI_FraunhoferIBP.4904af26.png";